export default {"src":"/_next/static/media/NotFoundIcon.60b3db4d.svg","height":16,"width":19,"blurWidth":0,"blurHeight":0};